export default "__VITE_ASSET__KF3BUmEK__"